import { Outlet, useOutletContext } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import BlockedPeriodPolicyDetails from 'modules/timeoff/components/BlockedPeriod/PolicyDetails'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const BlockedPeriodsDetailsPage = () => {
  const { back, blockedPeriodsPolicy, loading, isNotFound } = useOutletContext<RouteContextParams>()

  useEffect(() => {
    track(trackingEvents.timeoff.blockedPeriods.modifyBlockedPeriodStart)
  }, [])

  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <BlockedPeriodPolicyDetails
      loading={loading || loadingContractVersions}
      isNotFound={isNotFound}
      policy={blockedPeriodsPolicy}
      back={back}
      contractVersions={contractVersions}
    >
      <Outlet context={{ isNotFound, blockedPeriodsPolicy, loading }} />
    </BlockedPeriodPolicyDetails>
  )
}

export default BlockedPeriodsDetailsPage
